import { TruncatedText } from "@nulogy/components";
import { formatShortDateTime } from "components/helpers/format";
import PackmanagerJobLink from "components/pages/schedule/PackmanagerJobLink";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import React from "react";
import { ExecutionSummary, PublishResultSection } from "./PublishSummaryModalComponents";

function formatTime({ cellData }) {
  return formatShortDateTime(cellData);
}

function renderWorkOrder({ cellData }) {
  return <TruncatedText pl="x2">{cellData}</TruncatedText>;
}

export default function PublishSuccessTabContent({ createSuccessRows, updateSuccessRows, createTotal, updateTotal }) {
  const applicationContext = useApplicationContext();

  if (createSuccessRows.length === 0 && updateSuccessRows.length === 0)
    return <ExecutionSummary content="No jobs were published successfully." testId="success-summary" />;

  const createSuccessSummary = `Successfully created ${createSuccessRows.length} of ${createTotal} jobs.`;
  const updateSuccessSummary = `Successfully updated ${updateSuccessRows.length} of ${updateTotal} jobs.`;

  const successColumns = [
    {
      cellRenderer: renderWorkOrder,
      dataKey: "workOrder",
      label: "Work order",
      width: "25%",
    },
    {
      cellRenderer: renderJob,
      dataKey: "job",
      label: "Job",
      width: "25%",
    },
    {
      dataKey: "line",
      label: "Line",
      width: "25%",
    },
    {
      cellFormatter: formatTime,
      dataKey: "startTime",
      label: "Start time",
      width: "25%",
    },
  ];

  function renderJob({ cellData: jobId }) {
    return <PackmanagerJobLink applicationContext={applicationContext} jobId={jobId} />;
  }

  return (
    <>
      <PublishResultSection
        columns={successColumns}
        rows={createSuccessRows}
        summary={createSuccessSummary}
        testIdPrefix="create-success"
        title="Create"
      />

      <PublishResultSection
        columns={successColumns}
        rows={updateSuccessRows}
        summary={updateSuccessSummary}
        testIdPrefix="update-success"
        title="Update"
      />
    </>
  );
}
